export { default } from "bullitttime-embercomponents/components/class-group-results-teams-card";
